import React, { Component } from "react";
import injectSheet from "react-jss";
import Color from "color";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { flexUtils, palette } from "../../../Theme/Theme";
import * as Actions from "../../../Actions/Actions";
import { CSSTransitionGroup } from "react-transition-group"; // ES6
import { Link } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import { isMobile } from "react-device-detect";
import * as TempActions from "../../../Actions/TempPlaylistActions";
import {HotKeys} from 'react-hotkeys';

const FadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const Container = styled.div`
  animation: ${FadeIn} 0.3s linear;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2;
  background-color: ${Color("black")
    .alpha(0.8)
    .string()};
  position: fixed;
  top: 7vh;
  left: 0;
  min-height: 93vh;
  width: 100vw;
`;
const Popup = styled.div`
  border-radius: 10px;
  border: 1px solid ${palette.white};
  height: 50vh;
  width: 25vw;
  background-color: black;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  position: relative;
`;
const PlaylistsTitle = styled.div.attrs({
  children: "Add to Playlists"
})`
  width: 100%;
  height: 15%;
  border-bottom: 1px solid ${palette.white};
  color: ${palette.white};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2vw;
`;
const PlaylistContainer = styled.div`
  width: 100%;
  height: 85%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  overflow-y: auto;
`;
const Playlist = styled.div.attrs({
  children: props => props.content.title
})`
  transition: all 0.4s;
  color: ${palette.white};
  margin-top: 1rem;
  font-size: 2vw;
  z-index: 1;
  &:hover {
    color: ${palette.blue};
    cursor: pointer;
  }
`;
const Exit = styled.div.attrs({
  className: "fas fa-times"
})`
  transition: all 0.4s;
  color: ${palette.white};
  position: absolute;
  top: 1%;
  left: 2%;
  font-size: 2vw;
  &:hover {
    color: ${palette.pink};
    cursor: pointer;
  }
`;
const Success = styled.div.attrs({
  className: "fas fa-check"
})`
  color: ${palette.green};
  width: 100%;
  height: 85%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 5rem;
`;
const Loading = styled.div`
  color: ${palette.blue};
  width: 100%;
  height: 85%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 5rem;
`;

const CreateDefaultPlaylist = styled.div.attrs({
  children: "Create New Playlist"
})`
  transition: all 0.4s;
  color: ${palette.white};
  margin-top: 1rem;
  font-size: 1.5vw;
  &:hover {
    color: ${palette.blue};
    cursor: pointer;
  }
`;

const Input = styled.input.attrs({
  placeholder: "Playlist Name"
})`
  width: 60%;
  color: ${palette.white};
  background-color: black;
  border: none;
  font-size: 1.5vw;
  margin-top: 2.5rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid ${palette.white};
  &:focus {
    outline: none;
  }
`;

const Confirm = styled.div.attrs({
  className: "fas fa-check"
})`
  margin: 1rem;
  transition: all 0.7s;
  font-size: 2vw;
  color: ${palette.white};
  &:hover {
    color: ${props =>
      props.title !== "" ? `${palette.teal}` : `${palette.white}`};
    cursor: ${props => (props.title !== "" ? "pointer" : "auto")};
  }
`;
const Cancel = Confirm.extend.attrs({
  className: "fas fa-times"
})`
  extends: ${Confirm};
  &:hover {
    color: ${palette.pink};
  }
`;

const FlexRow = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
`;

class Playlists extends Component {
  state = {
    createNew: false,
    playlistTitle: ""
  };
  render() {
    const { playlistState } = this.props;

    const map = {
      createNew: 'enter'
    };

    const handlers = {
      createNew: this.checkInput
    }

    return (
      <HotKeys keyMap={map} handlers={handlers} >
      <Container>
        <Popup>
          <PlaylistsTitle />
          <Exit
            onClick={() => {
              this.props.dispatch({ type: "TOGGLE_ADD_TO_PLAYLIST" });
            }}
          />
          <PlaylistContainer>
            {!this.props.AddVideoState.started
              ? this.props.playlists.map((content, index) => {
                  return (
                    <Playlist
                      onClick={() => {
                        this.setState({createNew: false})
                        this.addToPlaylist(content.id);                        
                      }}
                      key={index}
                      content={content}
                    />
                  );
                })
              : this.returnMessage()}
            {this.state.createNew ? (
              <FlexRow>
                <Input
                  value={this.state.playlistTitle}
                  onInput={e => {
                    this.setState({ playlistTitle: e.target.value });
                  }}
                />
                <Confirm onClick={this.checkInput}/>
                <Cancel
                  onClick={() => {
                    this.setState({ createNew: false });
                  }}
                />
              </FlexRow>
            ) : (
              <CreateDefaultPlaylist
                onClick={() => {
                  this.setState({ createNew: true });
                }}
              />
            )}
          </PlaylistContainer>
        </Popup>
      </Container>
      </HotKeys>
    );
  }

  test = () => {
    // console.log('this is a test')
  }

  checkInput = () => {
    let title = JSON.parse(JSON.stringify(this.state.playlistTitle.trim()))
    if (title === '') {
      this.setState({playlistTitle: ''})
      return;
    }
    for (let i = 0; i < this.props.playlists.length; i++) {
      if (this.props.playlists[i].title === title) {
        this.setState({playlistTitle: ''})
        return;
      }
    }    
    this.CreateDefaultPlaylist()
  }

  CreateDefaultPlaylist = () => {
    this.props.dispatch(
      Actions.addPlaylist(this.props.user.token, this.state.playlistTitle)
    );
    this.setState({playlistTitle: '', createNew: !this.state.createNew})
  };
  componentDidMount() {
    this.props.dispatch({ type: "RESET_ADD_STATE" });
  }
  returnMessage = () => {
    if (this.props.AddVideoState.pending) {
      return <Loading className="fas fa-spinner fa-spin" />;
    }
    if (this.props.AddVideoState.success) {
      return <Success />;
    }
  };
  addToPlaylist = id => {
    this.props.dispatch(Actions.addShowToPlaylist(id, this.props.user.token));
  };
}

const mapStateToProps = state => {
  return {
    user: state.mainState.user,
    playlistState: state.mainState.playlistState,
    playlists: state.mainState.playlists,
    AddVideoState: state.mainState.AddVideoState
  };
};

export default withRouter(connect(mapStateToProps)(Playlists));



// WEBPACK FOOTER //
// ./src/js/Components/Home/Shows/Playlists.jsx